import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { db } from '../../services/firebase';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalProducts: 0,
    totalBlogs: 0,
    recentProducts: [],
    recentBlogs: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        // Fetch products count
        const productsRef = collection(db, 'products');
        const productsSnapshot = await getDocs(productsRef);
        
        // Fetch blogs count
        const blogsRef = collection(db, 'blogs');
        const blogsSnapshot = await getDocs(blogsRef);
        
        // Fetch recent products
        const recentProductsQuery = query(productsRef, orderBy('createdAt', 'desc'), limit(5));
        const recentProductsSnapshot = await getDocs(recentProductsQuery);
        
        // Fetch recent blogs
        const recentBlogsQuery = query(blogsRef, orderBy('publishedAt', 'desc'), limit(5));
        const recentBlogsSnapshot = await getDocs(recentBlogsQuery);
        
        setStats({
          totalProducts: productsSnapshot.size,
          totalBlogs: blogsSnapshot.size,
          recentProducts: recentProductsSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          })),
          recentBlogs: recentBlogsSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }))
        });
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  if (loading) {
    return (
      <div className="dashboard-loading">
        <div className="loading-spinner"></div>
        <p>Loading dashboard...</p>
      </div>
    );
  }

  return (
    <div className="admin-dashboard">
      {/* Stats Cards */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">🛍️</div>
          <div className="stat-content">
            <h3>{stats.totalProducts}</h3>
            <p>Total Products</p>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon">📝</div>
          <div className="stat-content">
            <h3>{stats.totalBlogs}</h3>
            <p>Total Blog Posts</p>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon">📊</div>
          <div className="stat-content">
            <h3>{stats.totalProducts + stats.totalBlogs}</h3>
            <p>Total Content</p>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon">✅</div>
          <div className="stat-content">
            <h3>Active</h3>
            <p>System Status</p>
          </div>
        </div>
      </div>

      {/* Recent Content */}
      <div className="dashboard-content">
        <div className="content-section">
          <h2>Recent Products</h2>
          <div className="content-list">
            {stats.recentProducts.length > 0 ? (
              stats.recentProducts.map(product => (
                <div key={product.id} className="content-item">
                  <div className="item-image">
                    <img src={product.image || '/logo.png'} alt={product.name} />
                  </div>
                  <div className="item-content">
                    <h4>{product.name}</h4>
                    <p>{product.description}</p>
                    <span className="item-meta">{product.category}</span>
                  </div>
                </div>
              ))
            ) : (
              <p className="no-content">No products found</p>
            )}
          </div>
        </div>
        
        <div className="content-section">
          <h2>Recent Blog Posts</h2>
          <div className="content-list">
            {stats.recentBlogs.length > 0 ? (
              stats.recentBlogs.map(blog => (
                <div key={blog.id} className="content-item">
                  <div className="item-image">
                    <img src={blog.image || '/logo.png'} alt={blog.title} />
                  </div>
                  <div className="item-content">
                    <h4>{blog.title}</h4>
                    <p>{blog.excerpt}</p>
                    <span className="item-meta">{blog.category}</span>
                  </div>
                </div>
              ))
            ) : (
              <p className="no-content">No blog posts found</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
